import { arrayOf, curry, PlatformEvent } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { set } from 'lib/sequence/component/state/value'
import { BLE_PERIPHERAL_CONNECTION_STATUS } from 'model/_shared/collection/bluetooth/constants'
import { hide } from 'lib/sequence/component/state/hidden'
import listConnectionStatus from 'app/_shared/events/collection/bluetooth/listConnectionStatus'
import getBatteryStatus from 'app/xEcoApm/event/getBatteryStatus'
import { disable } from 'lib/sequence/component/state/disabled'

const updatePeripheralStatus = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
): Promise<void> => {
  const detailAction = module[G.ACTIONS].sensorDetail
  const detailActionComponent = detailAction[G.COMPONENT]
  const { badges, insertCodeButton, scanCodeButton } = find(detailActionComponent)
  const { connectionStatus: connectionStatusBadge, batteryStatus } = find(badges)

  const {
    connectionStatus = BLE_PERIPHERAL_CONNECTION_STATUS.DISCONNECTED,
  } = event?.detail || event || {}
  const connectionStatusValue = listConnectionStatus(module, component, connectionStatus)
  const batteryStatusValue = arrayOf(await getBatteryStatus(module, component, event))

  set(connectionStatusBadge, connectionStatusValue)
  set(batteryStatus, batteryStatusValue)

  const { quickActions = [] } = detailAction[G.UI]
  const bluetoothAction = quickActions.find((quickAction: any) => quickAction.key === 'bluetooth')
  const actionButtons = detailActionComponent[G.ACTIONS][0]

  const isNotConnected = connectionStatus !== BLE_PERIPHERAL_CONNECTION_STATUS.CONNECTED

  bluetoothAction.active = !isNotConnected
  hide(actionButtons, isNotConnected)
  disable(insertCodeButton, isNotConnected)
  disable(scanCodeButton, isNotConnected)

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(updatePeripheralStatus)
